import React from 'react';

import { RichText } from '../RichText/RichText';

import classes from './BundleHeader.scss';

export const BundleHeader = ({ product }) => {
    const [firstPhoto] = product.media_entries || [];
    const wrapperStyles = {
        backgroundImage: `url(${firstPhoto.large_url})`,
    };

    return (
        <div className={classes.wrapper} style={wrapperStyles}>
            <div className={classes.content}>
                <h1 className={classes.title}>{product.name}</h1>
                <div className={classes.list}>
                    <RichText
                        className={classes.markdown}
                        content={product.short_description || 'missing short_description'}
                    />
                </div>
            </div>
        </div>
    );
};
